/**
 * Cache-busting for the static documents the chant reader fetches.
 *
 * The chant JSON, its variant index and the per-deity variant files are plain
 * files under `client/public`. The host serves them with NO `Cache-Control` and
 * NO `ETag`, so a browser is free to apply heuristic caching — and does. The
 * visible consequence: a step removed from the document and deployed was still
 * showing on a reader's screen, with no way for them to know the page was old.
 * The same fault, on the figures, cost an afternoon to a "something reverted
 * hours of work" that had reverted nothing.
 *
 * The figures are content-hashed by `tools/chant/pack_chants.py`. These files
 * cannot be: their URLs are authored in the document body, not derived. So they
 * carry the BUILD id instead, which is the right granularity anyway — a
 * document only ever changes by a deploy. Between deploys the URL is stable and
 * the file stays fully cached; after one it is a new URL and is fetched once.
 */
export function versioned(url: string): string {
  if (!url || /^(data|blob):/.test(url)) return url;
  const id = typeof __BUILD_ID__ === "string" ? __BUILD_ID__ : "";
  if (!id || url.includes("v=")) return url;
  return url + (url.includes("?") ? "&" : "?") + "v=" + id;
}
